import {useState} from "react";
import {Link} from "react-router-dom";

/**
 *  메인 > 센터 소개
 *
 */
const About = () => {

    // 1) 각 아코디언마다 id를 지정 2) id가 열렸음 여부를 알릴 배열 안에 있으면 열기

    // 열렸을 경우 배열의 인덱스를 저장하는 곳
    const [activeDescription, setActiveDescription] = useState([]);

    const isOpen = (index) => {

        // id가 activeDescription 배열에 있으면 true, 없으면 false
        return activeDescription.includes(index);
    }

    // 아이디가 배열 안에 있으면 제거 아니면 삽입
    const toggleDescription = (id) => {

        if (activeDescription.includes(id) === true) {

            return setActiveDescription(activeDescription.filter(index => index !== id));

        } else {
            return setActiveDescription([...activeDescription, id]);
        }
    }

    return (

        <main id="contents">
            <div className="sub-content">
                <div className="about-wrap">
                    <div className="cont-top">
                        <div className="w-set">
                            <div className="title-wrap">
                                <h2 className="title batang">한국근대교육사연구센터는</h2>
                            </div>
                        </div>
                    </div>
                    <div className="cont-btm">
                        <div className="w-set">
                            <div className="about-text-wrap">
                                <div className="text-wrap">
                                    <p className="sub-tit">한국근대교육사연구센터(이하 센터)는 한국 근현대 교육의 역사와 변화를 연구하고, 아카이브를 구축하여 한국 근대 교육사를 종합적으로 조망하고 있는 연구소입니다. </p>
                                    <p>
                                        본 연구소는 한국교원대학교 교육박물관을 중심으로, 다학제적 접근을 통해 한국 근대 교육의 역사를 체계적으로 조망하고 있습니다.
                                    </p>
                                    <p>
                                        연구센터에서는 한국 근현대 교육 자료를 포괄하는 데이터베이스를 구축하는 일을 중심적으로 수행합니다. 예를 들어 옛날 학교 선생님들의 이야기, 학교의 설립 배경, 학생들의 학교생활 등 한국 근대 교육의 이모저모를 데이터베이스화하여 누구나 쉽게 당시의 교육적 상황을 이해하고 접할 수 있는 장을 마련하고자 노력하고 있습니다.
                                    </p>
                                    <p>
                                        이 목표를 이루기 위해 연구센터에서는 회고록이나 자서전 등의 다양한 교육 관련 자료를 방대하게 수집하였고 그 외에도 조선총독부관보, 경기도보, 조선제학교일람과 같은 주요 자료를 활용해 교원 정보 및 초, 중, 고등 교육기관의 설립 및 운영 현황을 체계적으로 정리하였습니다.
                                    </p>
                                    <p>
                                        또한 한국 근대교육사의 연구 거점으로서 학술 대회와 세미나를 개최하고, 국내외 연구자와의 협업을 수행하며, 학교사 자료 수집 및 연구 지원을 강화하고 있습니다.
                                    </p>
                                    <p>
                                        향후 연구센터는 한국근현대교육자료 데이터베이스를 더욱 확대하여 교육박물관과 협력하며 한국교육사 디지털 아카이브를 구축할 계획입니다. 또한 지역 교육청, 교육기관과의 연계를 통해 학교사 자료 수집 및 연구 지원을 강화하고 이를 기반으로 디지털 인문학 연구를 선도하고자 합니다. 
                                    </p>
                                    <p className="sign">한국교원대학교 한국근대교육사연구센터장<span>이용기</span></p>
                                </div>
                            </div>
                            <div className="introduction-wrap">
                                <dl className="introduction">
                                    <dt>
                                        <Link to="#"
                                              className={isOpen(0) === true ? 'intro-tit on' : 'intro-tit'}
                                              onClick={() => toggleDescription(0)}>
                                            <p>센터활동 소개</p>
                                            <i className="i-toggle"></i>
                                        </Link>
                                    </dt>
                                    <dd>
                                        <div className="intro-view">
                                            <div className="text-wrap">
                                                <p>
                                                    한국근대교육사연구센터는 한국근현대교육사 아카이브 구축 거점지로서의 역할을 수행하고 있습니다. <br />
                                                    교육박물관과의 긴밀한 협력을 통해 DB구축의 일환으로 한국근현대 교육사 사료를 수집하거나, 구축한 DB자료 확산을 위해 교육사 자료 전시 및 다양한 교육 프로그램을 운영하며 교육 아카이브 연구 거점 토대를 마련하고 있습니다. 그 외에도 역사학 연구진 혹은 학문 후속 세대를 위한 정기적인 학술 세미나를 개최하며 연구 성과를 확산 및 공유하고, 인문학, 사회과학, 자연과학 등 다양한 분야의 연구진들과 융합 연구를 시도하고 있습니다. 
                                                </p>
                                                <p>
                                                    한국근대교육사센터는 다음과 같은 활동에 주력하고 있습니다. 
                                                </p>
                                                <p>
                                                    <strong style={{display: "block", marginBottom: "10px"}}>1. 한국 근현대 교육사 자료 허브 구축</strong>
                                                    - 교육박물관과의 협업을 통해 전국 교육박물관 및 전시관 네트워크를 형성하여, 한국 근현대 교육사 자료의 거점 역할을 수행합니다. <br />
                                                    - 교육박물관 연구센터와 학예연구실 간의 협력을 통해 대외적으로 공개 및 활용할 수 있는 한국근대교육사 종합DB를 구축합니다. <br />
                                                    - 한국 근현대 교육사 자료 서비스 홈페이지를 통해 주요 데이터를 공개하고, 플랫폼을 제공하여, 대중들이 손쉽게 자료를 확보할 수 있는 자료를 제공합니다. 
                                                </p>
                                                <p>
                                                    2. 교육 자료의 심층 연구와 역사학 연구진들과의 학문적 교류 <br />
                                                    - 교육박물관에 소장된 교육 DB자료를 토대로 각 학문 분과의 교과 교육사, 한국의 학력 사회, 학력 엘리트, 지역 유력자 형성 등을 분석하는 연구를 수행합니다. <br />
                                                    - 한국 근대교육사 연구 포럼과 세미나를 정기적으로 개최하여, 연구자 간의 학문적 교류를 촉진하고, 나아가 차세대 연구자를 양성합니다. 
                                                </p>
                                                <p>
                                                    3. 디지털 인문학과 다학제 연구선도<br />
                                                    - 한국근대교육사 DB를 디지털 인문학의 자료 출처로 공유하며, 인문학, 사회과학, 자연과학 분야와 융합 연구를 진행합니다. <br />
                                                    - 풍부한 교육 자료와 데이터를 기반으로 새로운 학술 연구 동향을 선도하며, 다양한 학문 분야의 융합적 접근을 통해 연구 영역을 확장합니다. 
                                                </p>
                                                <p>
                                                    4. 교육사 자료 전시 및 교육 프로그램 운영<br />
                                                    - 교육박물관에서 교육사 자료 전시 및 교육 프로그램을 운영합니다. 교육박물관에서는 소장 자료를 활용하여 대중들이 쉽게 근대교육사를 접할 수 있는 장을 마련합니다. <br />
                                                    - 그 외에도 학교와 연계한 프로그램을 운영합니다. 이를 통해 미래 세대에게 교육사의 중요성을 전달하며, 근대교육사에 대한 관심과 이해를 높이고자 노력합니다.
                                                </p>
                                                <p>
                                                    5. 한국 교육사 전공자 육성<br />
                                                    - 대학원 중심의 교육사 세미나를 운영하며, 대학원생끼리의 학문적 교류 활동을 지원합니다.<br /> 
                                                    - 학위 논문 및 학술지 논문 작성에 관한 기초자료를 제공함으로써 학문 후속 세대 양성을 도모하고 있습니다.
                                                </p>
                                                <p style={{textAlign: "right", fontWeight:"500"}}>2025년 2월 12일</p>
                                            </div>
                                        </div>
                                    </dd>
                                </dl>
                                {/* <dl className="introduction">
                                    <dt>
                                        <Link to="#" className={isOpen(1) === true ? 'intro-tit on' : 'intro-tit'}
                                              onClick={() => toggleDescription(1)}>
                                            <p>연구원 소개</p>
                                            <i className="i-toggle"></i>
                                        </Link>
                                    </dt>
                                    <dd>
                                        <div className="intro-view">
                                            <div className="text-wrap">
                                                <p>
                                                    연구원 소개가 들어갑니다.
                                                </p>
                                            </div>
                                        </div>
                                    </dd>
                                </dl> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
export default About;